module.exports = __webpack_public_path__ + "img/icon_1.b4b00c05.png";